import * as yup from 'yup';

import { strings } from '../strings';

export enum CreateAdminField {
  NAME = 'name',
  EMAIL = 'email',
  USERNAME = 'username',
  PASSWORD = 'password',
  CONFIRM_PASSWORD = 'confirm password',
  ROLE = 'role',
}

export const createAdminSchema = yup.object().shape({
  [CreateAdminField.NAME]: yup.string().required(strings.createAccNameRequired),
  [CreateAdminField.EMAIL]: yup.string().required(strings.createAccEmailRequired),
  [CreateAdminField.USERNAME]: yup.string().required(strings.createAccUsernameRequired),
  [CreateAdminField.PASSWORD]: yup
    .string()
    .trim()
    .required(strings.authPasswordRequired)
    .min(6, strings.createAccPasswordCharacters),
  [CreateAdminField.CONFIRM_PASSWORD]: yup
    .string()
    .trim()
    .required(strings.createAccConfirmPassword)
    .min(6, strings.createAccPasswordCharacters)
    .oneOf([yup.ref('password')], strings.createAccPasswordMatch),
  [CreateAdminField.ROLE]: yup
    .object()
    .shape({
      label: yup.string(),
      value: yup.string(),
    })
    .nullable()
    .required(strings.collectionIsRequired),
});
